document.addEventListener("DOMContentLoaded", function() {
	// Look for .hamburger
	var hamburger = document.querySelector(".hamburger"),
		menu = document.querySelector(".menu");
	// On click
	hamburger.addEventListener("click", function() {
		// Toggle class "is-active"
		hamburger.classList.toggle("is-active");
		// Do something else, like open/close menu
		menu.classList.toggle("is-active");
	});


    $('.main-carousel').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        wrapAround: true
    });
});
